import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

export const bullet = style({
  display: 'flex',
  selectors: {
    '&::before': {
      display: 'block',
      flexShrink: 0,
      width: themeVars.spacing.sm,
      height: themeVars.spacing.xs,
      margin: `${themeVars.spacing.sm} ${themeVars.spacing.sm} 0 0`,
      background: themeVars.color.semantic.surface.accentSecondary40,
      borderTopLeftRadius: themeVars.spacing.sm,
      borderTopRightRadius: themeVars.spacing.sm,
      content: '""',
    },
  },
});

export const css = {
  bullet,
};
